import http from 'utils/http';

const fetchingRestaurantLogo = idBusiness => {
  return http.get(`/menu/v1/image/business/${idBusiness}`);
};

const fetchingRestaurantCover = idRestaurant => {
  return http.get(`/menu/v1/image/url/restaurant/cover/${idRestaurant}`);
};

export default {
  fetchingRestaurantLogo,
  fetchingRestaurantCover
};



// WEBPACK FOOTER //
// ./src/services/restaurantService.js